// Shared colours. Each hex is defined exactly once: `messages` reuses the
// brand values above instead of restating them.
const primaryGreen = '#38CFAB';
const backgroundSection = '#F3F4F6';
const white = '#FFFFFF';

const palette = {
    custom: {
        primaryGreen: '#38CFAB',
        primaryGreenDark: '#0da183',
        primaryBlue: '#4F6C8D',
        secondaryGreen: '#92F7DF',
        secondaryBlue: '#E0FBFF',
        backgroundSection,
        backgroundBorder: '#E3E3E3',
        backgroundButton: '#F0F0F0',
        backgroundWhite: white,
        primaryTextGrey: '#504949',
        secondaryTextGrey: '#999999',
        whiteBackground: white,
        primaryYellow: '#CA8A04',
        secondaryYellow: '#FEFCE8'
    },
    // Customer Messages (Role Discussions) screen - Slack-style dark/light UI
    messages: {
        // Surfaces
        darkBg: '#1A1D21',
        darkRaise: '#222529',
        darkHover: '#222529',
        darkChip: '#2A2E33',
        darkLine: '#2D3136',
        darkBorder: '#3E4249',
        white,
        listBg: '#F8F9FA',
        fieldBg: backgroundSection,
        line: '#E5E7EB',
        fieldBorder: '#D1D5DB',
        rowHover: '#F8F9FA',
        hoverBg: '#F9FAFB',
        // Text
        ink: '#1D1C1D',
        heading: '#111827',
        body: '#4B5563',
        muted: '#6B7280',
        meta: '#616061',
        subtle: '#9CA3AF',
        onDark: '#E5E7EB',
        // Accents
        green: primaryGreen,
        greenInk: '#0A2540',
        greenSoft: '#E6FAF5',
        online: '#10B981',
        slackBlue: '#1264A3',
        linkBlue: '#0284C7',
        // Mention chips
        meBg: '#FEF3C7',
        meText: '#B45309',
        themBg: '#E0F2FE',
        themText: '#0284C7',
        // Default avatar tints
        avatarFallback: '#1E3A8A',
        userAvatar: '#C0392B',
        // Literals that previously sat inline in components
        iconGray: '#374151',
        danger: '#DC2626'
    },
    error: {
        main: '#FF6565',
    },
};

export default palette;
